module.exports = __webpack_public_path__ + "img/Epiito_App_Icons_Editor.2870173c.png";